export function Footer() {
  return null;
}
